import './styles/panel.css';
import './styles/chat.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ApiError } from './lib/api';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

// Sessão expirada no meio do uso: volta para o login.
queryClient.getQueryCache().subscribe((e) => {
  const err = e.query.state.error;
  if (err instanceof ApiError && err.status === 401 && e.query.queryKey[0] !== 'me') {
    void queryClient.invalidateQueries({ queryKey: ['me'] });
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
